export const spriteIconPrefix = 'fi';

export const spriteUtilityClasses = {
	size: `${spriteIconPrefix}-%s`
};
